"use strict";

exports.__esModule = true;
exports.ArticlePropType = void 0;

var tslib_1 = require("tslib");

var prop_types_1 = tslib_1.__importDefault(require("prop-types"));

exports.ArticlePropType = prop_types_1["default"].shape({
  _id: prop_types_1["default"].number.isRequired,
  name: prop_types_1["default"].string.isRequired,
  date: prop_types_1["default"].string,
  modified: prop_types_1["default"].string,
  perex: prop_types_1["default"].string,
  redirect: prop_types_1["default"].string,
  url: prop_types_1["default"].string,
  picture: prop_types_1["default"].shape({
    uri: prop_types_1["default"].string
  }),
  author: prop_types_1["default"].shape({
    id: prop_types_1["default"].string,
    name: prop_types_1["default"].string
  })
});